import _ from 'lodash'

export let utils = {
    deepCopy: function (obj) {
      // return JSON.parse(JSON.stringify(obj))
      if (typeof obj === "object") {
          if (_.isArray(obj)) {
              let newArr = [];
              for (let i = 0; i < obj.length; i++) newArr.push(obj[i]);
              return newArr;
          } else {
              let newObj = {};
              for (let key in obj) {
                  if (typeof obj[key] === 'object' && obj[key]!==null) {
                    newObj[key] = this.deepCopy(obj[key]);   //递归复制
                  } else {
                    newObj[key] = obj[key];
                  }
              }
              return newObj;
          }
      } else {
          return obj;
      }
  }
};